// extracted by mini-css-extract-plugin
export default {"title":"styles_title__OCYdz","list":"styles_list__g2M6s"};